<div class="flex flex-col space-y-2">
    <div class="flex flex-row w-full">
        <div class="flex flex-row gap-5 w-full">
            <div class="flex-1 min-w-0 rounded-lg bg-gray-50">
                <div
                    class="px-4 py-2 bg-gray-200 rounded-t-lg flex flex-row gap-5"
                >
                    <div class="text-lg font-medium pt-1">Bill To:</div>
                    @if (showEditButton) {
                        <button
                            mat-button
                            mat-flat-button
                            color="primary"
                            class="!rounded-lg !px-6 !py-0 !m-0"
                            (click)="onEditBillingInformationClick()"
                            type="button"
                        >
                            Edit
                        </button>
                    }
                </div>
                <div class="p-5">
                    <dl class="space-y-3 text-sm break-words">
                        <div>
                            <dd class="inline ml-1">
                                {{ orderSummaryData.organizationName }}
                            </dd>
                        </div>
                        <div>
                            <dd class="inline ml-1">
                                {{ orderSummaryData.contactName }}
                            </dd>
                        </div>
                        <div>
                            <dd class="inline ml-1">
                                {{ orderSummaryData.primaryStreetAddress }}
                            </dd>
                        </div>
                        @if (orderSummaryData.secondaryStreetAddress) {
                            <div>
                                <dd class="inline ml-1">
                                    {{
                                        orderSummaryData.secondaryStreetAddress
                                    }}
                                </dd>
                            </div>
                        }
                        <div>
                            <dd class="inline ml-1">{{ cityStateZip }}</dd>
                        </div>
                        <div>
                            <dd class="inline ml-1">
                                {{ orderSummaryData.contactEmail }}
                            </dd>
                        </div>
                    </dl>
                </div>
            </div>
            <div class="flex-1 min-w-0 rounded-lg bg-gray-50">
                <div class="px-4 py-3 bg-gray-200 rounded-t-lg">
                    <div class="text-lg font-medium">Order Information:</div>
                </div>
                <div class="p-5">
                    <dl class="space-y-3 text-sm break-words">
                        <div>
                            <dt class="inline font-medium">Order Number:</dt>
                            <dd class="inline ml-1">
                                {{ orderSummaryData.id }}
                            </dd>
                        </div>
                        <div>
                            <dt class="inline font-medium">Date:</dt>
                            <dd class="inline ml-1">
                                {{ orderSummaryData.date }}
                            </dd>
                        </div>
                        <div>
                            <dt class="inline font-medium">PO Number:</dt>
                            <dd class="inline ml-1">
                                {{ orderSummaryData.poNumber }}
                            </dd>
                        </div>
                        <div>
                            <dt class="inline font-medium">
                                Service Requested by:
                            </dt>
                            <dd class="inline ml-1">
                                {{ orderSummaryData.customerEmail }}
                            </dd>
                        </div>
                        <div>
                            <dt class="inline font-medium">EWA Contact:</dt>
                            <dd class="inline ml-1">
                                @if (orderSummaryData.coordinatorEmail) {
                                    <a
                                        class="text-primary-700 hover:underline"
                                        [href]="
                                            'mailto:' +
                                            orderSummaryData.coordinatorEmail
                                        "
                                    >
                                        {{ orderSummaryData.coordinatorName }}
                                    </a>
                                } @else {
                                    {{ orderSummaryData.coordinatorName }}
                                }
                            </dd>
                        </div>
                    </dl>
                </div>
            </div>
        </div>
    </div>
    <div class="flex flex-row w-full">
        <div class="w-full">
            <div class="overflow-hidden rounded-lg border border-gray-200">
                <table
                    class="w-full border-collapse bg-white text-sm break-words"
                >
                    <thead>
                        <tr class="bg-primary-50">
                            <th class="px-4 py-3 text-center font-medium">
                                Applicant
                            </th>
                            <th class="px-4 py-3 text-center font-medium">
                                TX Location
                            </th>
                            <th class="px-4 py-3 text-center font-medium">
                                App ID / PSCA ID
                            </th>
                            <th class="px-4 py-3 text-center font-medium">
                                Call Sign
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="border-b">
                            <td class="px-4 py-3 text-center">
                                {{ orderSummaryData.licenseeName }}
                            </td>
                            <td class="px-4 py-3 text-center">
                                {{ orderSummaryData.transmissionLocation }}
                            </td>
                            <td class="px-4 py-3 text-center">
                                <div>{{ orderSummaryData.salmonLogId }}</div>
                                <div class="text-gray-500">
                                    {{ orderSummaryData.pscaId }}
                                </div>
                            </td>
                            <td class="px-4 py-3 text-center">
                                {{ orderSummaryData.callSign }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
